
export default {
	permitList: state => state.permitIds.map(id => state.permits[id]),
	addedDiscounts: state => state.discountIds.map(id => state.discounts[id]),
}